import React from 'react';

function Bubble(props) {
	const value = props.value || 0;
	if (value <= 0) return null;
	const outer_circle_class = props.outer_bubble_class || 'ad_outer_bubble_circle';
	const circle_class = props.bubble_class || 'ad_bubble_circle';
	const text_class = props.text_class || 'ad_bubble_text';
	const dx = props.text_dx || -0.5;
	const dy = props.text_dy || 1.5;
	const size = props.size || 18-2;;
	const mid = size/2;
	const radius = mid-1;

	return (
		<svg viewBox={`0 0 ${size} ${size}`} width={size} height={size}>
			<circle className={outer_circle_class} cx={mid} cy={mid} r={radius+1}/>
			<circle className={circle_class} cx={mid} cy={mid} r={radius}/>
			<text textAnchor="middle" alignmentBaseline="middle" className={text_class} x={mid+dx} y={mid+dy}>{value}</text>
		</svg>
	);
}

export default Bubble;



// WEBPACK FOOTER //
// ./src/c/Bubble.js